import styled from 'styled-components'
import { Spacing } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'

export const FontContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${Spacing.L};

  ${Media.AbovePhone`
    gap: ${Spacing.M};
  `};

  ${Media.AboveTablet`
    gap: ${Spacing.L};
  `};
`
